module.exports = __webpack_public_path__ + "media/images/pepsi-logo_origin-e48c634f48659286dd4bf3ac5b2a896b.svg";